import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
  paymentLink?: string;
}
const initialState: IInitialState = {
  paymentLink: undefined,
};

const paymentLinkSlice = createSlice({
  name: 'paymentLink',
  initialState,
  reducers: {
    setPaymentLink(state, action: PayloadAction<IInitialState>) {
      state.paymentLink = action.payload.paymentLink;
    },
  },
});

export const paymentLinkActions = paymentLinkSlice.actions;
export default paymentLinkSlice.reducer;
